import { Flex, Spin } from 'antd';
import PropTypes from 'prop-types';

export const SuspenseFallback = ({ height, width, backgroundColor = '' }) => {
  return (
    <Flex
      justify="center"
      align="center"
      style={{
        height: height,
        width: width,
        backgroundColor: backgroundColor,
      }}
    >
      <Spin size="large" />
    </Flex>
  );
};

SuspenseFallback.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backgroundColor: PropTypes.string,
};
